export class GamingHistoryFilter {
	dateFrom?: string | null;
	dateTo?: string | null;
	casinoGameCategoryId?: string | null;
	liveGameTableGroup?: string | null;
	roundStatus?: string | null;
	onlyWin?: boolean | null;
	pageNumber: number;
}
